module.exports = __webpack_public_path__ + "img/like.49a00c48.svg";